import 'lazysizes';
import './assets/image.css';
